import { useEffect, useState } from 'react'

export const useNetworkStatus = () => {
    const [isOnline, setIsOnline] = useState(window.navigator.onLine)

    const updateNetworkStatus = () => setIsOnline(window.navigator.onLine)

    useEffect(() => {
        window.addEventListener('load', updateNetworkStatus)
        window.addEventListener('online', updateNetworkStatus)
        window.addEventListener('offline', updateNetworkStatus)

        return () => {
            window.removeEventListener('load', updateNetworkStatus)
            window.removeEventListener('online', updateNetworkStatus)
            window.removeEventListener('offline', updateNetworkStatus)
        }
    }, [])

    return {
        isOnline,
        isOffline: !isOnline,
    }
}
